import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Ebook from "../Ebook/Ebook";
import Header from "../Header/Header";
import { Upsell } from "../Upsell/Upsell";
import { post } from "../../app/shared/http";
import { withAuth } from "../../app/util/HOC";
import { useMediaQuery } from "react-responsive";
import { handleResponse } from "../../app/util/HOC";
import { handleException } from "../../app/util/util";
import HeaderNavBar from "../HeaderNavBar/HeaderNavBar";
import NoteBookContainer from "../noteBookContainer/NoteBookContainer";
import {
  PaneDirective,
  PanesDirective,
  SplitterComponent,
} from "@syncfusion/ej2-react-layouts";
import "./Read.css";
import $ from "jquery";
let labelVOList1 = [];
export function Read(props) {
  // get params and get the
  let { isbn, chapterid } = useParams();
  let ereaderWidth = "",
    noteBookWidth = "";
  let splitterInstance;
  const history = useHistory();
  const currentChapterId = chapterid;
  const componentOneRef = React.useRef();
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const bookVOLastReadPage = localStorage.getItem("lastPageReadNum");
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 1224px)" });
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const [validity, setValidity] = useState(false);
  const [briefVOList, setBriefVOList] = useState([]);
  const [eReaderSize, seteReaderSize] = useState("50%");
  const [noteBookSize, setNoteBookSize] = useState("50%");
  const [userSettingsVO, setUserSettingsVO] = useState([]);
  const [annotationVOList, setAnnotationVOList] = useState([]);
  const [renderChilComponent, setRenderChilComponent] = useState(false);
  const [bookVO, setBookVO] = useState(
    history.location.state !== undefined
      ? history.location.state.bookVOList
      : undefined,
  );
  const [bookInfo, setBookInfo] = useState(
    history.location.state !== undefined
      ? history.location.state.bookInfo
      : undefined,
  );
  const [labelVOList, setLabelVOList] = useState(
    history.location.state !== undefined
      ? history.location.state.labelVOList
      : undefined,
  );
  useEffect(() => {
    validate();
  }, [props, currentChapterId]);
  useEffect(() => {
    updateLastReadTime();
  }, []);
  async function validate() {
    setValidity(false);
    let reqData = {
      bookVO: { bookISBN: isbn, chapterId: chapterid },
    };
    // control comes here when the user hits the URL in the fresh tab
    post("/bookContentRetrievalService/getBookContentRV", reqData, "ENV")
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "false" && data.wkErrorCode) {
          handleException(data);
        }
        if (data.status === "true" && data.bookVO) {
          let responseBookVO = data.bookVO;
          responseBookVO.chapterId = data.bookVO.chapterId;
          let infoObj = {
            bookId: data.bookVO.bookId,
            bookISBN: data.bookVO.bookISBN,
            chapterId: reqData.bookVO.chapterId,
            chapterTitle: data.bookVO.chapterTitle,
            nextChapterId: data.bookVO.nextChapterId,
            lastReadPageNum: data.bookVO.lastReadPageNum,
            nextNavBarTitle: data.bookVO.nextNavBarTitle,
            pageHtmlLocation: data.bookVO.pageHtmlLocation,
            nextChapterTitle: data.bookVO.nextChapterTitle,
            labelName:
              data.bookVO.labelVOList !== undefined
                ? Array.isArray(labelVOList)
                  ? labelVOList[0].labelName
                  : ""
                : "",
            labelVOList:
              data.bookVO.labelVOList !== undefined
                ? Array.isArray(data.bookVO.labelVOList)
                  ? data.bookVO.labelVOList
                  : [data.bookVO.labelVOList]
                : null,
          };
          if (data.bookVO.labelVOList !== undefined) {
            labelVOList1 =
              data.bookVO.labelVOList !== undefined
                ? Array.isArray(data.bookVO.labelVOList)
                  ? data.bookVO.labelVOList
                  : [data.bookVO.labelVOList]
                : null;
            localStorage.setItem("labelVOList", JSON.stringify(labelVOList1));
          } else {
            localStorage.removeItem("labelVOList");
          }
          if (data.annotationVOList !== undefined) {
            let annotationVOList =
              data.annotationVOList !== undefined
                ? Array.isArray(data.annotationVOList)
                  ? data.annotationVOList
                  : [data.annotationVOList]
                : null;
            setAnnotationVOList(annotationVOList);
            localStorage.setItem(
              "colorCodeVOList",
              JSON.stringify(annotationVOList),
            );
          } else {
            localStorage.removeItem("colorCodeVOList");
          }
          if (data.briefVOList !== undefined) {
            let briefVOList =
              data.briefVOList !== undefined
                ? Array.isArray(data.briefVOList)
                  ? data.briefVOList
                  : [data.briefVOList]
                : null;
            setBriefVOList(briefVOList);
            localStorage.setItem("briefVOList", JSON.stringify(briefVOList));
          } else {
            localStorage.removeItem("briefVOList");
          }
          if (data.userSettingsVO !== undefined) {
            let userSettingsVO =
              data.userSettingsVO !== undefined
                ? Array.isArray(data.userSettingsVO)
                  ? data.userSettingsVO
                  : [data.userSettingsVO]
                : null;
            setUserSettingsVO(userSettingsVO);
            let ebookSize = parseInt(data.userSettingsVO.userScreenSize),
              ntbkSize = 50;
            if (ebookSize === 100) {
              ebookSize = 50;
              ntbkSize = 50;
            } else {
              ntbkSize = 100 - ebookSize;
            }
            seteReaderSize(ebookSize + "%");
            setNoteBookSize(ntbkSize + "%");
            localStorage.setItem("ereaderWidth", ebookSize + "%");
            localStorage.setItem("noteBookWidth", ntbkSize + "%");
            localStorage.setItem(
              "userSettingsVO",
              JSON.stringify(userSettingsVO),
            );
            localStorage.setItem(
              "userBookFontSize",
              userSettingsVO[0].prefferedFontSize
                ? userSettingsVO[0].prefferedFontSize
                : "14",
            );
            localStorage.setItem(
              "userBookLineHeight",
              userSettingsVO[0].prefferedLineSpacing
                ? userSettingsVO[0].prefferedLineSpacing
                : "12",
            );
          } else {
            localStorage.removeItem("userSettingsVO");
          }
          setBookInfo(infoObj);
          setBookVO(responseBookVO);
          setLabelVOList(labelVOList1);
          setRenderChilComponent(true);
          if (data.bookVO.validityStatus === "active") setValidity(true);
          else history.push("/dashboard");
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  const updateLastReadTime = () => {
    let requestData = {
      bookVO: { lastRead: null, bookISBN: isbn },
    };
    post("/OfflineService/updateExpirationDateValue", requestData, "ENV")
      .then(handleResponse)
      .then((response) => response.json())
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  function toggleMinimize() {
    splitterInstance.collapse(1);
    saveScreenSetting("expand", false);
    localStorage.setItem("screenMode", "expand");
    let eSplitBar = document.querySelector(".e-split-bar");
    let minimizeNoteBookLinkHide = document.querySelector(
      ".expandNoteBookLink",
    );
    let minimizeNoteBookLinkShow = document.querySelector(
      ".minimizeNoteBookLink",
    );
    let minimizeNoteBookLinkFlag = document
      .querySelector(".expandNoteBookLink")
      .getAttribute("aria-expanded");
    if (minimizeNoteBookLinkFlag === "true") {
      eSplitBar.classList.remove("e-static-pane");
      minimizeNoteBookLinkShow.style.visibility = "hidden";
      minimizeNoteBookLinkHide.style.visibility = "visible";
      setTimeout(() => {
        reCalculateNotesOnRight();
        reCalculateBriefOnRight();
      }, 2000);
    } else {
      eSplitBar.classList.add("e-static-pane");
      ereaderWidth = localStorage.getItem("ereaderWidth");
      minimizeNoteBookLinkHide.style.visibility = "hidden";
      noteBookWidth = localStorage.getItem("noteBookWidth");
      minimizeNoteBookLinkShow.style.visibility = "visible";
    }
    const pageNumTxtVal = document.getElementById("pageNumTxt");
    const miniBookLinkHide = document.getElementById("expandNoteBookLink");
    pageNumTxtVal && pageNumTxtVal.focus();
    miniBookLinkHide && miniBookLinkHide.focus();
  }
  function toggleExpand() {
    splitterInstance.expand(1);
    saveScreenSetting("split", false);
    localStorage.setItem("screenMode", "split");
    let eSplitBar = document.querySelector(".e-split-bar");
    let minimizeNoteBookLinkHide = document.querySelector(
      ".expandNoteBookLink",
    );
    let minimizeNoteBookLinkShow = document.querySelector(
      ".minimizeNoteBookLink",
    );
    let minimizeNoteBookLinkFlag = document
      .querySelector(".minimizeNoteBookLink")
      .getAttribute("aria-expanded");
    if (minimizeNoteBookLinkFlag === "false") {
      eSplitBar.classList.add("e-static-pane");
      ereaderWidth = localStorage.getItem("ereaderWidth");
      minimizeNoteBookLinkHide.style.visibility = "hidden";
      minimizeNoteBookLinkShow.style.visibility = "visible";
      noteBookWidth = localStorage.getItem("noteBookWidth");
      document.querySelectorAll("#percentage .e-pane")[1].style.display =
        "block";
      document.querySelectorAll("#percentage .e-pane")[0].style.flexBasis =
        ereaderWidth !== "" ? ereaderWidth : "50%";
      document.querySelectorAll("#percentage .e-pane")[1].style.flexBasis =
        noteBookWidth !== "" ? noteBookWidth : "50%";
      setTimeout(() => {
        reCalculateNotesOnRight();
        reCalculateBriefOnRight();
        document.querySelectorAll(".notesText").forEach(function (el) {
          el.style.display = "none";
        });
        document.querySelectorAll(".briefNotesText").forEach(function (el) {
          el.style.display = "none";
        });
        document.querySelectorAll(".linksText").forEach(function (el) {
          el.style.visibility = "hidden";
        });
      }, 2000);
    } else {
      eSplitBar.classList.remove("e-static-pane");
      minimizeNoteBookLinkShow.style.visibility = "hidden";
      minimizeNoteBookLinkHide.style.visibility = "visible";
    }
    const pageNumTxtVal = document.getElementById("pageNumTxt");
    const miniBookLink = document.getElementById("minimizeNoteBookLink");
    pageNumTxtVal && pageNumTxtVal.focus();
    miniBookLink && miniBookLink.focus();
  }
  const resizePanel = () => {
    if (document.querySelector(".expandNoteBookLink") !== null) {
      let minimizeNoteBookLinkFlag5 = document
        .querySelector(".expandNoteBookLink")
        .getAttribute("aria-expanded");
      if (minimizeNoteBookLinkFlag5 === "false") {
        setTimeout(() => {
          document.querySelectorAll("#percentage .e-pane")[0].style.flexBasis =
            "100%";
        }, 300);
      } else {
        setTimeout(() => {
          reCalculateNotesOnRight("resize");
          reCalculateBriefOnRight("resize");
        }, 2000);
      }
    }
  };
  const resizePercentage = () => {
    let resizeWidth = document.querySelectorAll("#percentage .e-pane")[0].style
      .flexBasis;
    if (
      resizeWidth !== undefined &&
      resizeWidth !== "" &&
      resizeWidth !== null
    ) {
      saveScreenSetting(parseInt(resizeWidth), true);
      localStorage.setItem("ereaderWidth", parseInt(resizeWidth) + "%");
      localStorage.setItem("noteBookWidth", 100 - parseInt(resizeWidth) + "%");
    }
  };
  const reCalculateNotesOnRight = (mode) => {
    let fetchedNoteText,
      fetchedNoteId,
      calculatedYvalue,
      fetchedBackgroundColor;
    document.querySelectorAll(".highlightedText").forEach(function (el) {
      if (document.querySelector("#notesDiv" + el.id) !== null) {
        fetchedNoteId = el.id;
        calculatedYvalue = document
          .getElementById(el.id)
          .getBoundingClientRect().top;
        fetchedNoteText = document
          .querySelector("#notesDiv" + el.id)
          .getAttribute("title");
        let gtId = document.getElementById(el.id);
        fetchedBackgroundColor = getComputedStyle(gtId).backgroundColor;
        componentOneRef.current.displayNotesOnRight(
          fetchedNoteText,
          fetchedNoteId,
          calculatedYvalue,
          fetchedBackgroundColor,
          false,
          mode,
        );
      }
    });
    document.querySelectorAll(".anchorElementText").forEach(function (el) {
      if (document.querySelector("#notesDiv" + el.id) !== null) {
        fetchedNoteId = el.id;
        calculatedYvalue = document
          .getElementById(el.id)
          .getBoundingClientRect().top;
        fetchedNoteText = document
          .querySelector("#notesDiv" + el.id)
          .getAttribute("title");
        let gtId = document.getElementById(el.id);
        fetchedBackgroundColor = getComputedStyle(gtId).backgroundColor;
        componentOneRef.current.displayNotesOnRight(
          fetchedNoteText,
          fetchedNoteId,
          calculatedYvalue,
          fetchedBackgroundColor,
          true,
          mode,
        );
      }
    });
    document.querySelectorAll(".anchorElementText").forEach(function (el) {
      if (document.querySelector("#linkDiv" + el.id) !== null) {
        fetchedNoteId = el.id;
        calculatedYvalue = document
          .getElementById(el.id)
          .getBoundingClientRect().top;
        let gtId = document.getElementById(el.id);
        fetchedBackgroundColor = getComputedStyle(gtId).backgroundColor;
        fetchedNoteText = document
          .querySelector("#linkDiv" + el.id)
          .previousElementSibling.getAttribute("urltext");
        let urlComments = document
          .querySelector("#linkDiv" + el.id)
          .previousElementSibling.getAttribute("urlComments");
        let shareLinkChecked = document
          .querySelector("#linkDiv" + el.id)
          .previousElementSibling.getAttribute("shareLinkChecked");
        let linkEditingForproffessor = document
          .querySelector("#linkDiv" + el.id)
          .previousElementSibling.getAttribute("linkEditingForproffessor");
        componentOneRef.current.displayLinksOnLeft(
          fetchedNoteId,
          calculatedYvalue,
          fetchedNoteText,
          urlComments,
          shareLinkChecked,
          linkEditingForproffessor,
          mode,
        );
      }
    });
  };
  const reCalculateBriefOnRight = (mode) => {
    let fetchedBriefNoteText,
      fetchedBriefLabelText,
      fetchedBriefNoteId,
      calculatedYvalue1,
      fetchedBackgroundColor1;
    document.querySelectorAll(".briefElementText").forEach(function (el) {
      if (document.querySelector("#briefAnchorElement" + el.id) !== null) {
        fetchedBriefNoteId = el.id;
        calculatedYvalue1 = document
          .getElementById(el.id)
          .getBoundingClientRect().top;
        fetchedBriefNoteText = document
          .querySelector("#briefAnchorElement" + el.id)
          .getAttribute("briefnote");
        fetchedBriefLabelText = document
          .querySelector("#briefAnchorElement" + el.id)
          .getAttribute("labelname");
        let gtId1 = document.getElementById(el.id);
        fetchedBackgroundColor1 = getComputedStyle(gtId1).backgroundColor;
        componentOneRef.current.displayBriefOnRight(
          fetchedBriefNoteId,
          fetchedBackgroundColor1,
          calculatedYvalue1,
          fetchedBriefLabelText,
          fetchedBriefNoteText,
          mode,
        );
      }
    });
  };
  const leftContent = () => {
    return (
      <Ebook
        ref={componentOneRef}
        bookVoPage={bookVOLastReadPage}
        userInfo={userVO}
        briefVOList={briefVOList}
        annotationVOList={annotationVOList}
        userSettingsVO={userSettingsVO}
        bookInfo={bookInfo}
        bookVO={bookVO}
        toggleExpand={(toggleExpand = toggleExpand.bind(this))}
      />
    );
  };
  const rightContent = () => {
    return (
      <div className="rightLayout content no-padding">
        <div
          className="col-lg-12 col-sm-12 col-xl-12 mTopTen"
          id="myNoteBookContainerBlock"
        >
          <a
            href="javascript:void(0);"
            id="minimizeNoteBookLink"
            role="button"
            className="text-right display-inline-block minimizeNoteBookLink pull-right"
            data-toggle="collapse"
            data-target="#minimizeNoteBook"
            aria-expanded="true"
            style={{ visibility: "visible" }}
            onClick={(toggleMinimize = toggleMinimize.bind(this))}
          >
            Minimize Notebook
          </a>
          {/* 47041 - A11Y: My Notebook content is not contained in a region */}
          {/* Original: <div id="minimizeNoteBook" className="collapse show"> */}
          <div
            id="minimizeNoteBook"
            className="collapse show"
            role="region"
            aria-label="My Notebook"
          >
            {/* 47037 - A11Y: My Notebook Case Brief note cards sections do not include heading markup */}
            {/* Original:
            <div
              id="myNoteBookText"
              className="text-left  display-inline-block myNoteBookText"
              aria-label="my Notebook"
            >
              My Notebook
            </div> */}
            <h1
              id="myNoteBookText"
              className="text-left  display-inline-block myNoteBookText"
              aria-label="my Notebook"
            >
              My Notebook
            </h1>
            <div
              id="expandNoteBookTabSection"
              className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding mTopTen"
            >
              <NoteBookContainer
                bookVO={bookVO}
                bookVoPage={bookVOLastReadPage}
                bookInfo={bookInfo}
                userInfo={userVO}
                chapterId={bookVO.chapterId}
                labelVOList={labelVOList}
                userSettingsVO={userSettingsVO}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const saveScreenSetting = (mode, resize) => {
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadPageNum: "",
          lastReadSectionId: "",
          lastViewedOutlineId: "",
          lastReadParagraphId: "",
          lastReadSubSectionId: "",
          pageNavigatingTo: "EReader",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "Bookshelf",
          lastReadBookId: bookInfo.bookId,
          lastReadChapterId: currentChapterId,
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
    };
    if (resize === false) {
      reqData.userSettingsVOList = [
        { userId: userVO.userId, userScreenMode: mode },
      ];
    } else if (resize === true) {
      reqData.userSettingsVOList = [
        { userId: userVO.userId, userScreenSize: mode },
      ];
    }
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    // 47042 - A11Y: Chapter link close button does not have an accessible name (aria-valuenow must be numeric, not a % string)
    // Original: $("#percentage").attr("aria-valuenow", `${mode}%`);
    $("#percentage").attr("aria-valuenow", mode);
    // 47042 - A11Y: Chapter link close button does not have an accessible name (aria-valuenow must be numeric, not a % string)
    // Original: $(".e-split-bar").attr("aria-valuenow", `${mode}%`);
    $(".e-split-bar").attr("aria-valuenow", mode);
    fetch(
      `${localStorage.getItem("ENV")}/manageOutlineService/saveUserScreenSettings`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "false" && data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const foucsOnNoteBookConainer = (event) => {
    event.preventDefault();
    const userSettingsVO = JSON.parse(
      localStorage.getItem("userSettingsVO"),
    )[0];
    var mode = localStorage.getItem("screenMode");
    const screen =
      mode === "split" || userSettingsVO.userScreenMode == "split"
        ? "minimizeNoteBookLink"
        : "expandNoteBookLink";
    document.getElementById(screen).focus();
  };
  useEffect(() => {
    setTimeout(() => {
      // 47042 - A11Y: Chapter link close button does not have an accessible name (aria-valuenow must be numeric, not a % string)
      // Original: $(".e-split-bar").attr("aria-valuenow", eReaderSize);
      $(".e-split-bar").attr("aria-valuenow", parseInt(eReaderSize));
    }, 1000);
  }, [eReaderSize]);
  return (
    <div className="Ereader">
      <button onClick={foucsOnNoteBookConainer} className="skip-to-main">
        Skip to the main
      </button>
      <Header userVO={userVO} bookVO={bookVO} pageName="read"></Header>
      {validity ? (
        <div>
          <HeaderNavBar
            bookVO={bookVO}
            userInfo={userVO}
            briefVOList={briefVOList}
            annotationVOList={annotationVOList}
            userSettingsVO={userSettingsVO}
          />
          {isDesktopOrLaptop && (
            <>
              <SplitterComponent
                id="percentage"
                height="auto"
                width="100%"
                resizing={resizePanel}
                // 47042 - A11Y: Chapter link close button does not have an accessible name (aria-valuenow must be numeric, not a % string)
                // Original: aria-valuenow={eReaderSize}
                aria-valuenow={parseInt(eReaderSize)}
                resizeStop={resizePercentage}
                ref={(splitter) => (splitterInstance = splitter)}
              >
                <PanesDirective>
                  <PaneDirective
                    size={eReaderSize}
                    content={leftContent}
                    min="35%"
                    max="65%"
                  />
                  <PaneDirective
                    size={noteBookSize}
                    content={rightContent}
                    min="35%"
                    max="65%"
                  />
                </PanesDirective>
              </SplitterComponent>
            </>
          )}
          {isTabletOrMobile && (
            <>
              <NoteBookContainer
                bookVO={bookVO}
                bookVoPage={bookVOLastReadPage}
                bookInfo={bookInfo}
                userInfo={userVO}
                chapterId={bookVO.chapterId}
                userSettingsVO={userSettingsVO}
                labelVOList={labelVOList}
              />
            </>
          )}
        </div>
      ) : null}
      <Upsell />
    </div>
  );
}
export default withAuth(Read);
